<template>
  <el-dialog :title="ruleForm.id ? '编辑采购产品' : '新增采购产品'"
             :visible.sync="visible"
             width="680px"
             @closed='handleClose'
             :close-on-press-escape="false">
    <el-form status-icon
             v-loading="loading"
             :model="ruleForm"
             :rules="rules"
             ref="ruleForm"
             label-width="90px">
      <el-form-item label="产品名称:"
                    prop="tagProductName">
        <el-input v-model="ruleForm.tagProductName"
                  :maxlength="32"></el-input>
      </el-form-item>
      <el-form-item label="产品规格:"
                    prop="size">
        <el-input v-model="ruleForm.size"
                  :maxlength="32"></el-input>
      </el-form-item>
      <el-form-item label="产品材质:"
                    prop="materialQuality">
        <el-input v-model="ruleForm.materialQuality"
                  :maxlength="32"></el-input>
      </el-form-item>
      <el-form-item label="产品备注:"
                    prop="tagProductNameRemark">
        <el-input v-model="ruleForm.tagProductNameRemark"
                  type="textarea"
                  :autosize="{ minRows: 4, maxRows: 6}"></el-input>
      </el-form-item>
      <el-form-item label="采购价:"
                    prop="stepPrices">
        <el-table border
                  :data="ruleForm.stepPrices">
          <el-table-column label="数量区间"
                           min-width="180">
            <template slot-scope="{ row  }">{{ row.minNum }}万枚（含）-{{ row.maxNum }}万枚（不含）</template>
          </el-table-column>
          <el-table-column label="采购单价"
                           min-width="100"
                           prop="unitPrice">
            <template slot-scope="{ row  }">{{ row.unitPrice }}元/枚</template>
          </el-table-column>
          <el-table-column label="其他费用"
                           min-width="120"
                           prop="otherFees">
            <template slot-scope="{ row  }">
              <div v-for="(item, index) in row.otherFees"
                   :key="index">{{ item.feeName }}：{{ item.fee }}元</div>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           width="100">
            <template slot-scope="{ row, $index }">
              <el-button type="text"
                         @click="editPrice(row, $index)">编辑</el-button>
              <el-button type="text"
                         :disabled="$index < ruleForm.stepPrices.length - 1"
                         @click="deletePrice($index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="addPrice"
                 type="primary"
                 :loading="loading">添加采购价</el-button>
      <el-button @click="visible = false"
                 :loading="loading">取 消</el-button>
      <el-button type="primary"
                 @click="handleSubmit"
                 :loading="loading">提 交</el-button>
    </span>
    <purchase-product-price-edit-modal ref="price"
                                       @update="handleUpdate" />
  </el-dialog>
</template>
<script>
import Purchase from '../../../service/purchase'
import PurchaseProductPriceEditModal from './purchase-product-price-edit-modal.vue'
export default {
  name: 'purchase-product-edit-modal',
  components: { PurchaseProductPriceEditModal },
  data () {
    return {
      loading: false,
      visible: false,
      ruleForm: { id: null, tagProductName: '', size: '', materialQuality: '', tagProductNameRemark: '', stepPrices: [] },
      rules: {
        tagProductName: [ { required: true, message: '请输入产品名称', trigger: 'blur' } ],
        size: [ { required: true, message: '请输入产品规格', trigger: 'blur' } ],
        materialQuality: [ { required: true, message: '请输入产品材质', trigger: 'blur' } ],
        tagProductNameRemark: [ { required: true, message: '请输入产品备注', trigger: 'blur' } ],
        stepPrices: [ { required: true, message: '请输入产品备注', trigger: 'change', type: 'array' } ]
      }
    }
  },
  methods: {
    handleClose () {
      this.ruleForm = { ...this.ruleForm, ...this.$options.data().ruleForm }
    },
    init (row = {}) {
      this.visible = true
      this.ruleForm = { ...this.ruleForm, ...row }
    },
    deletePrice (index) {
      this.ruleForm.stepPrices.splice(index, 1)
    },
    getMinPrice (index) {
      const { stepPrices } = this.ruleForm
      const idx = index === -1 ? stepPrices.length : index
      return idx > 0 ? stepPrices[idx - 1].maxNum : 1
    },
    addPrice () {
      this.$refs.price.init({ minNum: this.getMinPrice(-1) }, { index: -1 })
    },
    editPrice (row, index) {
      this.$refs.price.init({ ...row, otherFees: JSON.parse(JSON.stringify(row.otherFees)) }, { index })
    },
    handleUpdate (row, index) {
      if (index === -1) {
        this.ruleForm.stepPrices.push({ ...row })
      } else {
        this.$set(this.ruleForm.stepPrices, index, { ...row })
      }
    },
    handleSubmit () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          Purchase[this.ruleForm.id ? 'updatetagproduct' : 'addtagproduct']({ ...this.ruleForm })
            .then(res => {
              const { result, message } = res.data
              this.loading = false
              if ([0].includes(result)) {
                this.$message.success('提交成功')
                this.visible = false
                this.$emit('fetch')
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        }
      })
    }
  }
}
</script>
